import SalesHome from './sales-view';

export default SalesHome;
